import * as z from "zod";

export const UserVehicleSchema = z.object({
  id: z.string().uuid(),
  user_id: z.string().uuid(),
  model_id: z.string().uuid(),
  fleet_number: z.string().max(50).nullable().optional(),
  fleet_id: z.string().uuid().nullable().optional(),
  notes: z.string().nullable().optional(),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const createUserVehicleSchema = UserVehicleSchema.omit({
  id: true,
  created: true,
  updated: true,
});

export const updateUserVehicleSchema = UserVehicleSchema.pick({
  model_id: true,
  fleet_number: true,
  fleet_id: true,
  notes: true,
}).partial();

export const UserVehicleProductSchema = z.object({
  id: z.string().uuid(),
  user_vehicle_id: z.string().uuid(),
  order_id: z.string().uuid(),
  cart_item_id: z.string().uuid(),
  created: z
    .date()
    .optional()
    .default(() => new Date()),
  updated: z
    .date()
    .optional()
    .default(() => new Date()),
});

export const addProductToUserVehicleSchema = z.object({
  user_vehicle_id: z.string().uuid(),
  order_id: z.string().uuid(),
  cart_item_id: z.string().uuid(),
});

export const removeProductFromUserVehicleSchema = z.object({
  user_vehicle_product_id: z.string().uuid(),
});
